import { Guid } from "@/Common/Models/Guid";
import { Patient } from "@/Common/Models/Patient/Patient";
import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";
import { DisplayContextEnum } from "@/Patient/Models/MedicalNote/Enum/DisplayContextEnum";
import { Encounter } from "@/Patient/Models/MedicalSummary/Encounter";

/**
 * Component IDs by rendering priority in the medical note forms registry.
 */
enum MedicalNoteFormsRegistryComponentId {
    Cnesst
}

/**
 * Props for the medical note forms registry.
 */
interface IMedicalNoteFormsRegistryProps {
    isEditMode: boolean;
    isReadOnly: boolean;
    encounter: Encounter;
    patientModel: Patient;
    patientContactId: Guid;
    displayContext: DisplayContextEnum;
}

/**
 * Medical note forms registry.
 */
class MedicalNoteFormsRegistry extends BaseComponentRegistry<MedicalNoteFormsRegistryComponentId, IMedicalNoteFormsRegistryProps> {}

/**
 * Medical note forms registry React component.
 */
const MedicalNoteFormsRegistryView = createRegistryListView(() => MedicalNoteFormsRegistry.getInstance());

export {
    IMedicalNoteFormsRegistryProps,
    MedicalNoteFormsRegistry,
    MedicalNoteFormsRegistryComponentId,
    MedicalNoteFormsRegistryView
};
